// Dust-kick — pure emission intensity for the puffs kicked up under the running player. 0 while
// standing/walking slowly, ramping with speed (dashes kick up the most). Render-only: the renderer
// turns this into pooled ground motes behind the player. No sim impact.

/**
 * Emission intensity 0..1 from the player's speed (world units/sec). Below `walk` no dust; ramps
 * to full by `full` (base move speed ~5.2, dash higher). Pure + clamped.
 */
export function dustKick(speed: number, walk = 2.5, full = 9): number {
  if (speed <= walk) return 0
  return Math.max(0, Math.min(1, (speed - walk) / (full - walk)))
}
